/**
 * Pure eviction-reason helpers (EE-392), kept in this leaf entry point so both `@ee/common/forms` and
 * `@ee/common/services` can import them without a `services` <-> `forms` cycle.
 */

/** Trimmed, blank-free, de-duplicated keeping the first occurrence — the backend normalizer's rules. */
export function normalizeEvictionReasons(reasons: unknown): string[] {
  if (!Array.isArray(reasons)) {
    return [];
  }
  const cleaned = reasons
    .filter((r): r is string => typeof r === 'string')
    .map(r => r.trim())
    .filter(r => !!r);
  return [...new Set(cleaned)];
}

/**
 * The reasons a STORED case holds: the normalized `eviction_reasons` list when it has any entry, else the
 * trimmed `eviction_reason` scalar, else none — the backend `EvictionReasonsNormalizer.normalize` rule.
 * An empty list is NOT authoritative: the server always serializes `eviction_reasons`, so a document the
 * backfill has not reached arrives as `{eviction_reason: "X", eviction_reasons: []}` and must still read
 * as `["X"]`.
 */
export function storedEvictionReasons(
  obj: {eviction_reason?: unknown; eviction_reasons?: unknown} | null | undefined
): string[] {
  const list = normalizeEvictionReasons(obj?.eviction_reasons);
  return list.length ? list : normalizeEvictionReasons([obj?.eviction_reason]);
}
